import axios from "axios";
import { findKey } from "core-js/fn/dict";
import Vue from 'vue';

export default {
  state: {
    center: null,
    zoom: null,
    ownersFilters: [
      {
        attribute: "",
        operator: "==",
        value: "",
        mergeOperator: "OR"
      }
    ],
    projectsFilters: [
      {
        attribute: "",
        operator: "==",
        value: "",
        mergeOperator: "OR"
      }
    ],
    layersGroups: [],
    filesUploadsProgress: {},
    isOffersMapViewFilter: localStorage.getItem("isOffersMapViewFilter") == 'true' ? true : false,
    isParcelsMapViewFilter: localStorage.getItem("isParcelsMapViewFilter") == 'true' ? true : false
  },
  getters: {
    getLayersGroups(state) {
      return state.layersGroups;
    },
    getOwnersFilters(state) {
      return state.ownersFilters;
    },
    getProjectsFilters(state) {
      return state.projectsFilters;
    },
    getFilesUploadsProgress(state) {
      return state.filesUploadsProgress;
    },
    getOffersMapViewFilter(state) {
      return state.isOffersMapViewFilter;
    },
    getParcelsMapViewFilter(state) {
      return state.isParcelsMapViewFilter;
    }
  },
  mutations: {
    setLayersGroups(state, value) {
      state.layersGroups = value;
    },
    setOwnersFilters(state, value) {
      state.ownersFilters = value;
    },
    setProjectsFilters(state, value) {
      state.projectsFilters = value;
    },
    cancelFileUploadProgress(state, value) {
      const file = state.filesUploadsProgress[value];
      file.canceled = true;
      Vue.set(state.filesUploadsProgress, value, file);
    },
    deleteFileUploadProgress(state, value) {
      Vue.delete(state.filesUploadsProgress, value);
    },
    finishFileUploadProgress(state, value) {
      const { id, success, error } = value;
      const file = state.filesUploadsProgress[id];
      if (!file) {
        return;
      }
      file.progress = success ? 101 : 104;
      if (error) {
        file.error = error;
      }
      Vue.set(state.filesUploadsProgress, id, file);
    },
    setFileUploadProgress(state, value) {
      const file = state.filesUploadsProgress[value.id];
      if (file && file.canceled) {
        return;
      }
      state.filesUploadsProgress = { ...state.filesUploadsProgress, [value.id]: value };
    },
    setOffersMapViewFilter(state, value) {
      state.isOffersMapViewFilter = value;
      localStorage.setItem('isOffersMapViewFilter', value);
    },
    setParcelsMapViewFilter(state, value) {
      state.isParcelsMapViewFilter = value;
      localStorage.setItem('isParcelsMapViewFilter', value);
    },
  },
  actions: {
    addLayer(ctx, payload) {
      return axios
        .post("/layers", payload)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    deleteLayer(ctx, lid) {
      return axios
        .delete(`/layers/${lid}`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    getLayers() {
      return axios
        .get("/layers")
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    postFile({ commit, state }, payload) {
      const { formData, progressInfo } = payload;
      const fileUploadRequest = axios.CancelToken.source();
      let currentProgress;
      return axios
        .post("/files", formData, {cancelToken: fileUploadRequest.token, onUploadProgress: progressEvent => {
          currentProgress = state.filesUploadsProgress[progressInfo.id];
          if (progressInfo && progressInfo.id) {
            if (currentProgress && currentProgress.canceled) {
              fileUploadRequest.cancel();
              commit('deleteFileUploadProgress', progressInfo.id);
            } else {
              progressInfo.progress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
              commit('setFileUploadProgress', progressInfo);
            }
          }
        }})
        .then(r => {
          if (!currentProgress) {
            commit('finishFileUploadProgress', { id: progressInfo.id, success: true })
          } else if (progressInfo && progressInfo.id && currentProgress && !currentProgress.canceled) {
            commit('finishFileUploadProgress', { id: progressInfo.id, success: true })
          }
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          const errorMsg = error.response ? error.response.data.error : '';
          if (progressInfo && progressInfo.id && currentProgress && !currentProgress.canceled) {
            commit('finishFileUploadProgress', { id: progressInfo.id, success: false, error: errorMsg });
          }
          return { msg: error.response.data.error };
        });
    },
    // comments
    getComments(ctx, payload) {
      const { type, id, params } = payload;
      return axios
        .get(`/comments/${type}/${id}`, {
          params
        })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e.response.data.message;
        });
    },
    postComment(ctx, payload) {
      //console.log(payload);
      return axios
        .post(`/comments/${payload.entity_type}/${payload.entity_id}`, payload)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e.response.data.message;
        });
    },
    deleteComment(ctx, id) {
      return axios
        .delete(`/comments/${id}`)
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(e => {
          return e;
        });
    },
    // attachments
    getAttachments(ctx, payload) {
      const { type, id, params } = payload;
      return axios
        .get(`/files/${type}/${id}`, { params })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e.response.data.message;
        });
    },
    deleteAttachment(ctx, id) {
      return axios
        .delete(`/files/${id}`)
        .then(r => {
          if (r) {
            return r;
          } else {
            return false;
          }
        })
        .catch(e => {
          return e;
        });
    },
    async getCurrencyPrice(ctx, { currency }) {
      try {
        const response = await axios({
          method: "get",
          url: `https://api.nbp.pl/api/exchangerates/rates/A/${currency}/?format=json`,
          baseURL: "/"
        });
        return response;
      } catch (e) {
        return e;
      }
    },
    async addressSearch(ctx, address) {
      return axios
        .get(`/address_search?address=${address}`)
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    async getLayersGroups({ commit }) {
      return axios
        .get('/layers/groups')
        .then(r => {
          if (r) {
            commit('setLayersGroups', r.data.data);
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response;
        });
    },
    async addLayersGroup({ dispatch }, payload) {
      return axios
        .post('/layers/groups', payload)
        .then(async r => {
          if (r) {
            await dispatch('getLayersGroups');
            return r;
          }
          return false;
        })
        .catch(e => {
          return e.response.data.message;
        });
    },
    async editLayersGroup({ dispatch }, payload) {
      const { id } = payload;
      delete payload.id;
      return axios
        .put(`/layers/groups/${id}`, payload)
        .then(async r => {
          if (r) {
            await dispatch('getLayersGroups');
            return r;
          }
          return false;
        })
        .catch(e => {
          return e.response.data.message;
        });
    },
    async deleteLayerGroup({ dispatch }, payload) {
      const { id, deleteLayers } = payload;
      return axios
        .delete(`/layers/groups/${id}`, {params: {with_layers: deleteLayers}})
        .then(async r => {
          if (r) {
            await dispatch('getLayersGroups');
            return r;
          } else {
            return false;
          }
        })
        .catch(e => {
          return e.response.data.message;
        });
    },
    async getAttributesSchema(ctx, payload) {
      const {entity, simpleAttributesOnly, publicSchema = true} = payload;
      return axios
        .get(`/${entity}/schema`, {params: {simple_attributes_only: simpleAttributesOnly || false, public: publicSchema}})
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response;
        });
    },
    async fieldCalculator(ctx, payload) {
      const { entityType, data } = payload;
      return axios
        .post(`/field_calculator/${entityType}`, { data })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          return e;
        });
    },
    async getFilterHints(ctx, payload) {
      const {data, entity, attribute, params} = payload;
      return axios
        .post(`/filter_hint/${entity}/${attribute}`, data, { params })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(e => {
          console.log(e.response);
          return e.response;
        });
    }
  }
};
